import React, { Component } from 'react';
import Typist from 'react-typist';
import CVPlanetCard from './CVPlanetCard';
import CVEntry from './CVEntry';

import 'react-responsive-modal/lib/react-responsive-modal.css';
import Modal from 'react-responsive-modal';

import OnVisible from 'react-on-visible';

import { Comet } from './Comet';
import { AstronautSvg } from './AstronautSvg';
import { AsteroidsSvg } from './AsteroidsSvg';
import { CVEntries } from './CVEntries';

class CV extends Component {

	constructor(props) {
		super(props);

		this.state = {
			modalOpen: false,
			modalText: "",
			modalTitle: ""
		};
	}

	onOpenModal = (description, title) => {
    	this.setState({ modalOpen: true, modalText: description, modalTitle: title });
  	};

  	onCloseModal = () => {
    	this.setState({ modalOpen: false, modalText: "", modalTitle: "" });
  	};

	currentAge(birthday) {
		let differenceMilliseconds = Date.now() - birthday.getTime();
		let difference = new Date(differenceMilliseconds);
		return "" + Math.abs(difference.getUTCFullYear() - 1970);
	}

	renderCvEntries() {

		let newMap = CVEntries.map((cvEntry, cvEntryIndex) => {

			let content;

			switch(cvEntry.entryType)
			{
				case "planet":
					content = (
						<CVPlanetCard 
							title={cvEntry.title} 
							planet="planet1.svg"
							left={true}
							key={1}
							explanation={true}
							entries={cvEntry.entries}
							index={cvEntryIndex}
						 />
					);
				break;

				case "stars":
					content = this.renderSkills(cvEntry.title, cvEntry.entries, cvEntryIndex);
				break;

				case "spacestation":
					content = this.renderWorkexperience(cvEntry.title, cvEntry.entries, cvEntryIndex);
				break;

				case "asteroids":
					content = this.renderEducation(cvEntry.title, cvEntry.entries, cvEntryIndex);
				break;

				case "contact":
					content = this.renderContact(cvEntry.title, cvEntryIndex);
				break;

				default:
					content = '';
				break;
			}

			return (
				<CVEntry key={cvEntryIndex} title={cvEntry.title}>
					{content}
				</CVEntry>
			);
		});

		return newMap;
	}

	renderWorkexperience(title, workExperience, index) {

		return (
			<OnVisible className='layout-cs-workexperience'>
				<div className="layout-cs-workexperience">
					<div className="background"></div>
					<img src="/gfx/spacestation.svg" width="100%" alt="Station" className="layout-cs-spacestation-spacer" />

					<div className="experiences">
						{workExperience.map((experience, exi) => {
							let experienceLogo = `/gfx/logos/${experience.logo}`;
							return (
								<div className="workexperience" key={exi}>
									<img src={experienceLogo} alt={experience.company} onClick={() => {
										this.onOpenModal(experience.description, experience.company);
									}} />
								</div>
							);
						})}
					</div>
				</div>
			</OnVisible>
		);
	}

	renderEducation(title, educations, index) {

		return (
			<div className="layout-cs-education">
				<div className="background">
					<div className="asteroids" id="asteroids" dangerouslySetInnerHTML={{
    					__html: AsteroidsSvg
					}}></div>
				</div>
				<div className="educations">
					{educations.map((education, eix) => {
						let educationLogo = `/gfx/logos/${education.logo}`;
						return (
							<div className="education" key={eix}>
								<img src={educationLogo} alt={education.institute} onClick={() => {
									this.onOpenModal(education.description, education.institute);
								}} />
							</div>
						);
					})}
				</div>
			</div>
		);
	}

	renderContact(title, index) {
		return (
			<div className="satellite-container">
				<div className="satellite"><img src="/gfx/satellite.svg" alt="Satellite" /></div>
				<div className="satellite-icon icon-email" onClick={() => { window.open('mailto:' + atob("cmlrQHJpa2tlcHBlbC5ubA==")); }}>
					<img src="/gfx/email.svg" alt="Email" />
				</div>
				<div className="satellite-icon icon-linkedin" onClick={() => { window.location = "https://www.linkedin.com/in/hj-keppel-288b1524/"; }}>
					<img src="/gfx/logos/linkedin.svg" alt="LinkedIn" />
				</div>
			</div>
		);
	}

	renderSkills(title, skills, index) {
		return(
			<div className="layout-cs-skills">
				{skills.map((skill, index) => {
					let skillImage = `/gfx/` + skill.icon;
					return (
						<div className="layout-cs-skill" key={index} onClick={() => {
							this.onOpenModal(skill.description, skill.title);
						}}>
							<img src="/gfx/stars.svg" width="100%" alt="Stars" className="layout-cs-skill-background" />
							<img src={skillImage} alt={skill.title} className="layout-cs-skill-icon" />
						</div>
					);
				})}
			</div>
		);
	}

	renderCVItems() {
		const { modalOpen } = this.state;
		let birthDay = new Date("1992-07-14");
		let currentAge = this.currentAge(birthDay);

		return (
			<div className="layout-cs">

				<div className="easter-egg cat">
					<img src="/gfx/cat.svg" alt="Cat" title="" />
				</div>

				<div className="layout-cs-entries">
					<div className="layout-cs-card full-height">
						<div id="layout-comet" dangerouslySetInnerHTML={{
	    					__html: Comet
						}}></div>
						<div className="layout-header">
		          			<h1>Rik Keppel</h1>
		          			<h2>Web developer</h2>
		        		</div>
					</div>
					<div className="layout-cs-card">
						<div className="speach-bubble bubble-full">
							<div className="speach-bubble-content">
								<Typist avgTypingDelay={30}>
									Mijn naam is Rik Keppel, een {currentAge}-jarige web developer wonende in Alkmaar. Sinds 2011 ontwikkel ik met passie webbased applicaties.
								</Typist>
							</div>
						</div>
						<div className="astronaut" id="astronaut" dangerouslySetInnerHTML={{
	    					__html: AstronautSvg
						}}></div>
					</div>

					{this.renderCvEntries()}
				</div>

				<Modal open={modalOpen} onClose={this.onCloseModal} little animationDuration={2} classNames={{
					modal: "layout-cs-modal"
				}}><h2>{this.state.modalTitle}</h2>{this.state.modalText}</Modal>
			</div>
		);
	}

  render() {
    return (
        this.renderCVItems()
    );
  }
}

export default CV;


// WEBPACK FOOTER //
// ./src/CV.js